module.exports = __webpack_public_path__ + "static/bg-wave-croped-850c1aeb7588b3c8063c3d6b4aca86e9.png";